export const deliveryReport = {
	title: "Delivery Reports",
	description: "Monitor and analyze your establishment's delivery orders.",
	tabs: {
		general: "General Report",
	},
	selectPeriod: "Select a period",
	periodOptions: {
		today: "Today",
		last7days: "Last 7 days",
		last15days: "Last 15 days",
		last30days: "Last 30 days",
		last90days: "Last 90 days",
		custom: "Select a period",
	},
	generalTab: {
		export: "Export",
		filtersToolbar: {
			search: "Search order #",
			vendors: "Platform",
			vendorsPlaceholder: "Select platform",
			status: "Status",
			statusPlaceholder: "Select status",
			period: "Period",
			periodPlaceholder: "Select period",
			back: "Back",
			apply: "Apply",
		},
		table: {
			columns: {
				vendor: "Platform",
				reference: "Order #",
				status: "Status",
				date: "Date",
				orderCreatedAt: "Order Time",
				orderEndAt: "Order Completed",
				value: "Total",
				viewMore: "View More",
			},
			summary: "Period total",
			seeMore: "See more details",
		},
		vendorType: {
			rappi: "Rappi",
			coala: "Coala",
			ifood: "iFood",
			keeta: "Keeta",
		},
		orderStatus: {
			cancelled: "Cancelled",
			concluded: "Concluded",
			confirmed: "Confirmed",
		},
		orderDetailsDrawer: {
			orderRangeWithEnd:
				"Order placed on {{startDate}} at {{startHour}}<br>Completed at {{endHour}}",
			orderRangeWithoutEnd: "Order placed on {{startDate}} at {{startHour}}",
			order: "Order",
			paymentDetails: "FINANCIAL DETAILS",
			paymentMethod: "Payment method",
			subTotal: "Sale subtotal",
			discountAndImpost: "Fees and discounts",
			totalReceive: "Total to receive",
			discountValue: "-{{value}} - Discount coupon",
			discountValueDeliveryFee: "-{{value}} - Discount on delivery fee",
			discountValueDeliveryFeeMarketplace:
				"-{{value}} - Discount on delivery fee of the {{marketplace}}",
			discountValueMarketplace: "-{{value}} - Discount on the {{marketplace}}",
			deliveryFee: "{{value}} - Delivery Fee",
			tip: "{{value}} - Tip",
			paymentMethodType: {
				creditCardInPlace: "Credit card",
				creditCardOnline: "Credit card",
				debitCardOnline: "Debit card",
				debitCardInPlace: "Debit card",
				cash: "Cash",
				voucherInPlace: "Voucher",
				ame: "Ame",
				pix: "Pix",
			},
		},
	},
	orderItemsTable: {
		columns: {
			count: "Qty.",
			name: "Item",
			baseUnitPrice: "Unit Price",
			totalUnitPrice: "Subtotal",
		},
		summary: "Subtotal",
		totalReceive: "TOTAL TO RECEIVE",
	},
	orderStatus: {
		ready: "Ready",
		canceled: "Cancelled",
		concluded: "Concluded",
		dispatched: "Dispatched",
		integrated: "Integrated",
		placed: "Created",
		pendingPayment: "Payment pending",
		pickupAreAssigned: "Customer on site",
		scheduled: "Scheduled",
	},
};
